import { render } from "./ObjectsDataList.vue?vue&type=template&id=c8d2a730&scoped=true"
import script from "./ObjectsDataList.vue?vue&type=script&lang=ts"
export * from "./ObjectsDataList.vue?vue&type=script&lang=ts"

import "./ObjectsDataList.vue?vue&type=style&index=0&id=c8d2a730&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c8d2a730"

export default script